<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="selected"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
          @change="setSociety()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="user in usersData"
              :key="user.key"
              @click="userSelected(user)"
            >
              <v-list-item-title>
                {{ user.login }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-account-supervisor-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";
import { ProfileUserConnector } from "../../Database/ProfileUserConnector.js";

export default {
  components: {},
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      selected: 0,
      socData: [],
      usersData: [],
      allUsers: [],
    };
  },
  created() {
    this.getUsers();
    this.getSociety();
  },
  methods: {
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;

        // Add all on the top of list
        this.socData.unshift({ id_soc: 0, name: this.$t("dialog.all") });
      });
    },
    getUsers() {
      this.userConnector.getUsersData().then((users) => {
        // TODO: format in db server
        this.usersData = users.map((data) => {
          return {
            id_usr: data.id_usr,
            login: data.login,
            password: "",
            name: data.lastname,
            firstname: data.firstname,
            phone: data.phone,
            access: data.right_id,
            soc_id: data.soc_id,
          };
        });

        // Keep a complete copy of all users
        this.allUsers = this.usersData;
      });
    },
    setSociety() {
      // Reset to all users
      this.usersData = this.allUsers;

      // If a society is selected filter on it
      if (this.selected > 0) {
        this.usersData = this.allUsers.filter((user) => {
          return user.soc_id == this.selected;
        });
      }
    },
    userSelected(userObj) {
      const user = {
        userId: userObj.id_usr,
        socId: userObj.soc_id,
        rightId: userObj.access,
        name: userObj.firstname + " " + userObj.name,
        login: userObj.login,
        permissions: "1|2|3|4|5|6|7|8|9",
        players: "",
        dir: "",
        aikido: "salsa",
      };

      this.$store.dispatch("authentified", user).user;

      this.$router.push({ path: "/home" });
    },
  },
};
</script>

<style></style>
